import { getSystemConfigs } from "../api/generated/wrappers/backdata";
import { createQueryKeys } from "./create-query-keys";
const systemConfigQueryKeys = createQueryKeys("systemConfig", {
    list: (category) => ({
        queryKey: ["list", category ?? "all"],
        queryFn: async () => await getSystemConfigs(category),
    }),
});
export default systemConfigQueryKeys;
